import { render } from "./HowSect.vue?vue&type=template&id=4255461b&ts=true"
import script from "./HowSect.vue?vue&type=script&lang=ts"
export * from "./HowSect.vue?vue&type=script&lang=ts"

import "./HowSect.vue?vue&type=style&index=0&id=4255461b&lang=scss"

import exportComponent from "/Users/damodar/Documents/PROGRAMMING/STUDING/everypay/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__